export default "__VITE_ASSET__Bf98kMcA__"